export enum InterviewStatus {
    Scheduled = "Scheduled",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
    Incomplete = "Incomplete",
    AwaitingSelection = "AwaitingSelection"
}
